import { useCallback, useState } from "react";

const STORAGE_KEYS = {
  list: "mgmt-monthly-report-list-tour-completed",
  detail: "mgmt-monthly-report-detail-tour-completed",
  formCreate: "mgmt-monthly-report-form-create-tour-completed",
  formEdit: "mgmt-monthly-report-form-edit-tour-completed",
} as const;

export type MonthlyReportTourPage = keyof typeof STORAGE_KEYS;

export function useMonthlyReportTour(page: MonthlyReportTourPage) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const storageKey = STORAGE_KEYS[page];

  const hasCompletedTour = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(storageKey) === "true";
  };

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data: { status?: string; type?: string; index?: number }) => {
      if (data.index !== undefined) setStepIndex(data.index);
      if (
        data.status === "finished" ||
        data.status === "skipped" ||
        data.type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    hasCompletedTour: hasCompletedTour(),
    handleJoyrideCallback,
  };
}
